import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import Select from 'src/common/refactoredComponents/select/Select';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useTranslation } from 'react-i18next';
import { sizes } from 'src/styles/Media.styled';
import AlertMsg from 'src/pages/equity/components/cart/priceOverride/common/AlertMsg.jsx';
import { TextBold } from 'src/common/components/filter/Filters.styled.jsx';
import {
    OrderDetailTabBody,
    MainDiv,
    Heading,
    SubHeading,
    Container2,
    Box,
    RoleBox,
    ButtonDiv,
    OrderDetailTabBodyContainer,
} from './editSsa.styled';

const EditSalesStructureAssignment = (props) => {
    const options = [
        { value: 'Jeff Gutowski', label: 'MDT Spine Sales Rep' },
        { value: 'Nate Houser', label: 'MDT Spine CS' },
        { value: 'Aaron Mary', label: 'MDT Spine CS' },
        { value: 'Marc Vecchio', label: 'MDT Spine CS' },
    ];
    const [selectedOption] = useState('Select a User');
    const { t } = useTranslation();

    return (
        <>
            <OrderDetailTabBodyContainer>
                <OrderDetailTabBody>
                    <Grid
                        container
                        justifyContent="space-between"
                        direction="row"
                        spacing={1}
                    >
                        <div
                            style={{
                                display: 'flex',
                                width: 'max-content',
                                padding:
                                    window.innerWidth <= sizes.mobileDevice
                                        ? '20px 16px 0px 16px'
                                        : '15px 10px 0px 7px',
                            }}
                        >
                            <AlertMsg
                                message={
                                   t('admin.nameDetails.alertMessage')
                                }
                            />
                        </div>

                        <Grid item xs={12} sm={6} md={6} mobile={12}>
                            <MainDiv margin={'15px 10px 10px 5px'}>
                                <RoleBox>
                                    <SubHeading>{
                                   t('admin.nameDetails.role')
                                }</SubHeading>
                                    <Container2>
                                        <Select
                                            id="admin-editSsa-nameDetails-role"
                                            placeholder={t(
                                                'proxies.addAProxy.selectuser'
                                            )}
                                            labelColor={'#202124'}
                                            options={options}
                                            // itemTemplate={selectedUserItemTemplate}
                                            value={selectedOption}
                                            // onChange={handleChange}
                                        />
                                    </Container2>
                                </RoleBox>
                            </MainDiv>

                            <MainDiv>
                                <Heading>{
                                   t('admin.nameDetails.addNewAssignment')
                                }</Heading>
                                <Box>
                                    <SubHeading>{
                                   t('admin.nameDetails.area')
                                }</SubHeading>
                                    <Container2>
                                        <Select
                                            id="admin-editSsa-nameDetails-area"
                                            placeholder={t(
                                                'proxies.addAProxy.selectuser'
                                            )}
                                            labelColor={'#202124'}
                                            options={options}
                                            // itemTemplate={selectedUserItemTemplate}
                                            value={selectedOption}
                                            // onChange={handleChange}
                                        />
                                    </Container2>
                                </Box>
                                <Box>
                                    <SubHeading>{
                                   t('admin.nameDetails.region')
                                }</SubHeading>
                                    <Container2>
                                        <Select
                                            id="admin-editSsa-nameDetails-region"
                                            placeholder={t(
                                                'proxies.addAProxy.selectuser'
                                            )}
                                            labelColor={'#202124'}
                                            options={options}
                                            // itemTemplate={selectedUserItemTemplate}
                                            value={selectedOption}
                                            // onChange={handleChange}
                                        />
                                    </Container2>
                                </Box>
                                <Box>
                                    <SubHeading>{
                                   t('admin.nameDetails.district')
                                }</SubHeading>
                                    <Container2>
                                        <Select
                                            id="admin-editSsa-nameDetails-district"
                                            placeholder={t(
                                                'proxies.addAProxy.selectuser'
                                            )}
                                            labelColor={'#202124'}
                                            options={options}
                                            // itemTemplate={selectedUserItemTemplate}
                                            value={selectedOption}
                                            // onChange={handleChange}
                                        />
                                    </Container2>
                                </Box>
                                <Box>
                                    <SubHeading>{
                                   t('admin.nameDetails.territory')
                                }</SubHeading>
                                    <Container2>
                                        <Select
                                            id="admin-editSsa-nameDetails-territory"
                                            placeholder={t(
                                                'proxies.addAProxy.selectuser'
                                            )}
                                            labelColor={'#202124'}
                                            options={options}
                                            // itemTemplate={selectedUserItemTemplate}
                                            value={selectedOption}
                                            // onChange={handleChange}
                                        />
                                    </Container2>
                                </Box>
                                <ButtonDiv>
                                    <Button
                                       id={'page-admin-nameDetails-add'}
                                        show={true}
                                       // secondary={true}
                                        width={'131px'}
                                        mobileWidth={'160px'}
                                        height={'38px'}
                                        //border={'1px solid #9A9A9A'}
                                        // clicked={onSave}
                                        variant={ButtonStyles.secondaryGreyBorder}
                                    >
                                        <TextBold color={'#9A9A9A'}>
                                        {
                                   t('admin.nameDetails.add')
                                }
                                        </TextBold>
                                    </Button>
                                </ButtonDiv>
                            </MainDiv>
                        </Grid>
                    </Grid>
                </OrderDetailTabBody>
            </OrderDetailTabBodyContainer>
            <BottomNavigation
                opacity={'1'}
                border={'1px solid #1010EB'}
                position={'absolute'}
                padding={'11px 25px !important'}
                justifyContent={'flex-end'}
                moblieJustifyContent={'center'}
                bottom={'0'}
                left={'0'}
                right={'0'}
            >
                <Button
                    id={'page-admin-nameDetails-cancel'}
                    show={true}
                    //secondary={true}
                    // btnlook-001
                    variant={ButtonStyles.secondary}
                    border={'1px solid #140F4B'}
                    top={'659px'}
                    left={'670px'}
                    width={'131px'}
                    mobileWidth={'160px'}
                    height={'38px'}
                    margin={
                        window.innerWidth <= sizes.mobileDevice
                            ? '0px 6px 0px 0px'
                            : '0px 20px 0px 0'
                    }
                    clicked={props.handleClose}
                >
                    <TextBold color={'#140F4B'}>
                        {t('accounts.shipToAddress.cancel')}
                    </TextBold>
                </Button>

                <Button
                    id={'page-admin-nameDetails-save'}
                    show={true}
                    //primary={true}
                    variant={ButtonStyles.primary}
                    top={'659px'}
                    left={'670px'}
                    width={'131px'}
                    mobileWidth={'160px'}
                    height={'38px'}
                    // clicked={onSave}
                >
                    <TextBold color={'#FFFFFF'}>
                        {t('accounts.shipToAddress.save')}
                    </TextBold>
                </Button>
            </BottomNavigation>
        </>
    );
};

export default EditSalesStructureAssignment;
